import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import { primaryBlue, textColorGray } from 'theme/mainColors';

const defaultValidationErrorMessage = 'Invalid input. Enter a different value.';

class InvoiceTextField extends React.PureComponent {
  state = {
    touched: false,
    validationErrorMessage: ''
  };

  setValidationErrorMessage = (event, value, condition) => {
    this.setState({
      validationErrorMessage: condition
        ? defaultValidationErrorMessage
        : ''
    }, () => {
      this.props.onChange(event, value, this.state.validationErrorMessage);
    });
  }

  checkInvoiceNumberValue = (value, invoiceNumberRegEx) => !invoiceNumberRegEx.test(value) || value.length > this.props.stringMaxLength;

  handleTextFieldChange = (event, value) => {
    const decimalNumberRegEx = new RegExp(/^$|^[+-]?\d{1,18}(\.\d{1,4})?$/, 'g');
    const integerNumberRegEx = new RegExp(/^$|^\d+$/, 'g');
    const lineNumberRegEx = new RegExp(/^\d+$/, 'g');
    const invoiceNumberRegEx = new RegExp(/^(?!\s*$).+/, 'g');
    const eventValue = event.target.name;
    switch (this.props.dataType) {
      case 'decimal':
        this.setValidationErrorMessage(eventValue, value, !decimalNumberRegEx.test(value));
        break;
      case 'int':
        eventValue === 'number' ? 
          this.setValidationErrorMessage(eventValue, value, !lineNumberRegEx.test(value)) : 
          this.setValidationErrorMessage(eventValue, value, !integerNumberRegEx.test(value));
        break;
      case 'string':
        eventValue === 'invoice' ?
          this.setValidationErrorMessage(eventValue, value, this.checkInvoiceNumberValue(value, invoiceNumberRegEx)) : 
          this.setValidationErrorMessage(eventValue, value, value.length > this.props.stringMaxLength);
        break;
      default:
        break;
    }
    
  };

  handleOnBlur = ev => {
    this.setState({ touched: true });
    this.props.onBlur(ev);
  };

  render() {
    const {
      name,
      label,
      value,
      hintText,
      fullWidth,
      style,
      required,
      pristineForm,
      errorText,
      disabled
    } = this.props;
    return (
      <TextField
        fullWidth={ fullWidth }
        floatingLabelText={ label }
        value={ value }
        name={ name }
        onChange={ this.handleTextFieldChange }
        onBlur={ this.handleOnBlur }
        floatingLabelStyle={ {
          color: textColorGray,
          whiteSpace: 'nowrap',
          maxWidth: '100%',
          textOverflow: 'ellipsis',
          overflow: 'hidden'
        } }
        underlineStyle={ { borderColor: textColorGray } }
        underlineFocusStyle={ { borderColor: primaryBlue } }
        inputStyle={ { fontSize: 15 } }
        style={ style }
        errorText={
          this.state.validationErrorMessage ||
          errorText ||
          (required && !value && this.state.touched && !pristineForm
            ? 'This field is required'
            : '')
        }
        hintText={ hintText }
        disabled={ disabled }
      />
    );
  }
}

InvoiceTextField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  required: PropTypes.bool,
  pristineForm: PropTypes.bool,
  hintText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  fullWidth: PropTypes.bool,
  onBlur: PropTypes.func,
  style: PropTypes.object,
  errorText: PropTypes.string,
  dataType: PropTypes.oneOf(['string', 'int', 'decimal']),
  stringMaxLength: PropTypes.number,
  disabled: PropTypes.bool
};

InvoiceTextField.defaultProps = {
  hintText: '',
  required: false,
  fullWidth: true,
  pristineForm: false,
  style: {},
  onBlur: () => null,
  errorText: '',
  disabled: false,
  dataType: 'string',
  stringMaxLength: 100
};

export default InvoiceTextField;



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/InvoiceTextField.js